import React from "react";
import styles from "../../ScholarshipApplication/ScholarshipApplicationDetails/ScholarshipApplicationDetails.module.scss";
import { Card, Box, Typography, Chip  } from "@mui/material";
import FormGenerator from "../../../components/FormBuilder/FormBuilder";
import useStudentEvaluationForm from "./useStudentEvaluationForm";
import {StudentEvaluationFormType} from "../../../types/formTypes"


const StudentEvaluationForm = () => {
    const {studentEvaluationDetail, fundsFormFields, handleSubmit, isLoading, isError, id} = useStudentEvaluationForm()
    return (<Card
        style={{
            padding: "2rem",
            border: 0,
            boxShadow: "none",
            background: "none",

        }}
    >
        <Box className={"cardBoxUI"}>   
            <Box className={styles.header}>
            <Typography variant="h5" className={styles.title}>
                Evaluation Form
            </Typography>
            <Box className={styles.navigationButtons}>
                <Typography variant="h6">
                    Student Name
                </Typography>
                {studentEvaluationDetail?.name && <Chip label={studentEvaluationDetail?.name} color="info" sx={{fontSize:16}} />}
                <Typography variant="h6">
                    Scholarship ID
                </Typography>
                {studentEvaluationDetail?.scholarship_id && <Chip label={studentEvaluationDetail?.scholarship_id} color="success"  sx={{fontSize:16}}/>}
            </Box>
        </Box>
        { !isLoading && !isError && <FormGenerator<StudentEvaluationFormType> fields={fundsFormFields} showSubmit={id ? false : true } onSubmit={(data: any) => handleSubmit(data)} direction="column"/>}
        </Box>
    </Card>)
}

export default StudentEvaluationForm